import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { useAsync } from '@nuxtjs/composition-api';
import { SButton, SLoader, SOption, SSelect } from '@strana-artw/ui-kit';
import { computed, defineComponent, nextTick, onBeforeMount, ref, useCssModule } from 'vue';
import { accountApiConfig } from '@/config/api/account';
import { useClientApi } from '@/plugins/api/lk';
import { useAuthStrategy } from '@/shared/composables';
import { fullLogDecorate } from '@/shared/lib';
import { pageScrollService } from '@/shared/services';
import { AppTitle, SimpleOverlay } from '@/shared/ui';
import { useAuthStore } from '@/store/authStore';
import { useCitiesStore } from '@/store/cities';
/**
 * Модалка принудительного выбора города продаж при логине
 */
export default /*#__PURE__*/_defineComponent({
  __name: 'ModalSelectSaleCity',
  setup: function setup(__props) {
    var _authStore$user$city_, _authStore$user;
    defineComponent({
      name: 'ModalSelectSaleCity'
    });
    var citiesStore = useCitiesStore();
    useAsync(function () {
      return citiesStore.getCities();
    }, "RXTdRlz3IjtontSOPi6Uww==");
    var authStore = useAuthStore();
    var selectedCityId = ref((_authStore$user$city_ = (_authStore$user = authStore.user) === null || _authStore$user === void 0 || (_authStore$user = _authStore$user.city_of_sale) === null || _authStore$user === void 0 ? void 0 : _authStore$user.id) !== null && _authStore$user$city_ !== void 0 ? _authStore$user$city_ : undefined);
    var errorMessage = ref('');
    var loading = ref(false);
    var hideAnimationEnded = ref(false);
    var hidingAnimation = ref(false);
    var showComponent = computed(function () {
      return !hideAnimationEnded.value;
    });
    var newUser;
    var saveCity = fullLogDecorate(function () {
      var strategy = useAuthStrategy();
      if (!strategy) {
        throw new Error('user role was empty');
      }
      return useClientApi().$patch(accountApiConfig.profile(strategy), {
        city_of_sale_id: selectedCityId.value
      }).then(function (response) {
        hidingAnimation.value = true;
        newUser = response;
      });
    }, 'SelectSaleCityModal');
    function onSaveButtonClick() {
      return _onSaveButtonClick.apply(this, arguments);
    }
    function _onSaveButtonClick() {
      _onSaveButtonClick = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(selectedCityId.value == null)) {
                _context.next = 1;
                break;
              }
              errorMessage.value = 'Введите город продажи';
              return _context.abrupt("return");
            case 1:
              loading.value = true;
              _context.next = 2;
              return saveCity();
            case 2:
              loading.value = false;
              hidingAnimation.value = true;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _onSaveButtonClick.apply(this, arguments);
    }
    var $style = useCssModule();
    function onAnimationEnd(e) {
      if (e.animationName === $style['hide-swipe']) {
        hideAnimationEnded.value = true;
        pageScrollService.unlock();
        nextTick(function () {
          if (newUser) {
            authStore.setUser(newUser);
          }
        });
      }
    }
    onBeforeMount(function () {
      if (process.client) {
        pageScrollService.lock();
      }
    });
    return {
      __sfc: true,
      citiesStore: citiesStore,
      authStore: authStore,
      selectedCityId: selectedCityId,
      errorMessage: errorMessage,
      loading: loading,
      hideAnimationEnded: hideAnimationEnded,
      hidingAnimation: hidingAnimation,
      showComponent: showComponent,
      newUser: newUser,
      saveCity: saveCity,
      onSaveButtonClick: onSaveButtonClick,
      $style: $style,
      onAnimationEnd: onAnimationEnd,
      SButton: SButton,
      SLoader: SLoader,
      SOption: SOption,
      SSelect: SSelect,
      AppTitle: AppTitle,
      SimpleOverlay: SimpleOverlay
    };
  }
});